/* eslint-disable @typescript-eslint/no-explicit-any */
import { useApolloClient, useQuery } from '@apollo/client'
import { Chip, Grid, TextField, Typography } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useDebouncedCallback } from 'use-debounce/lib'
import { useBudgetStyles } from '../../../component/Budget/styles'
import { LIST_ORDERS, REMOVE_ORDER } from '../../../graphql/queries'
import theme from '../../../theme'
import { useSubscriptionStyles } from '../Subscription/styles'
import OrderCard from './OrderCard'
const OrdersList = (): JSX.Element => {
  const classes = useSubscriptionStyles()
  const budgetClasses = useBudgetStyles()

  const [filters, setFilters] = React.useState<{
    q: string
    and?: { status: string }
  }>({ q: '' })
  const [debouncedFilters, setDebouncedFilters] = React.useState<{
    q: string
    and?: { status: string }
  }>({ q: '' })

  const { data, refetch, loading } = useQuery(LIST_ORDERS, {
    fetchPolicy: 'network-only',
    variables: {
      params: { ...debouncedFilters, sort: { createdAt: 'DESC' } }
    }
  })

  const client = useApolloClient()
  const { enqueueSnackbar } = useSnackbar()
  const orders: any[] = data?.orders?.edges

  const debouncedSetData = useDebouncedCallback(setDebouncedFilters, 400)
  useEffect(() => {
    debouncedSetData(filters)
  }, [filters])

  const handeDelete = (order: any) => {
    const confirm = window.confirm('Deseja realmente excluir este pedido?')
    if (!confirm) return
    client
      .mutate({
        mutation: REMOVE_ORDER,
        variables: {
          filter: {
            ids: [order.id]
          }
        }
      })
      .then(({ data }) => {
        enqueueSnackbar(data?.removeOrders.message)
        refetch()
      })
  }

  return (
    <>
      <Grid container alignItems="center" justify="space-around" spacing={3}>
        <Grid item xs={12} md={1}>
          <Typography variant="h6">Filtros:</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            value={filters.q}
            onChange={e => setFilters({ ...filters, q: e.target.value })}
            label="Nome do paciente"
          />
        </Grid>
        <Grid item xs={4} md={1}>
          <Chip
            className={
              filters?.and?.status === 'Sale' ? budgetClasses.paid : ''
            }
            style={{
              cursor: 'pointer',
              backgroundColor:
                filters?.and?.status === 'Sale'
                  ? theme.palette.success.main
                  : '',
              color:
                filters?.and?.status === 'Sale'
                  ? theme.palette.success.contrastText
                  : ''
            }}
            onClick={() => {
              if (filters.and?.status === 'Sale') {
                return setFilters({ ...filters, and: undefined })
              }
              setFilters({ ...filters, and: { status: 'Sale' } })
            }}
            label="Pago"
          />
        </Grid>
        <Grid item xs={4} md={1}>
          <Chip
            style={{
              cursor: 'pointer',
              backgroundColor:
                filters?.and?.status === 'Budge'
                  ? theme.palette.warning.main
                  : '',
              color:
                filters?.and?.status === 'Budge'
                  ? theme.palette.warning.contrastText
                  : ''
            }}
            onClick={() => {
              if (filters.and?.status === 'Budge') {
                return setFilters({ ...filters, and: undefined })
              }
              setFilters({ ...filters, and: { status: 'Budge' } })
            }}
            label="Orçamento"
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 25 }}>
        <Grid item xs={12} className={classes.overflow}>
          {loading && <h1>Carregando...</h1>}
          {!loading && !orders.length && (
            <h1>Nenhum resultado encontrado...</h1>
          )}
          {orders?.map((order: any, index) => (
            <OrderCard
              onDelete={() => handeDelete(order)}
              key={index}
              order={{
                id: order.id,
                date: order.createdAt.format,
                name: order.customer.name,
                value: order.payment.netAmount,
                state: order.status,
                ...order
              }}
            />
          ))}
        </Grid>
      </Grid>
    </>
  )
}

export default OrdersList
